import { forwardRef } from 'react';
import { Search, ScanLine } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface ProductSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const ProductSearchBar = forwardRef<HTMLInputElement, ProductSearchBarProps>(
  ({ value, onChange }, ref) => {
    return (
      <div className="relative w-full">
        <Search className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-ink-400" />
        <Input
          ref={ref}
          data-scanner-target
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Cari produk atau scan barcode…  (F2)"
          className="pl-12 pr-12"
          aria-label="Cari produk"
        />
        <ScanLine className="pointer-events-none absolute right-4 top-1/2 h-5 w-5 -translate-y-1/2 text-ink-400/70" />
      </div>
    );
  },
);
ProductSearchBar.displayName = 'ProductSearchBar';
